import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Message Alert Outline"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-message-alert-outline',
    templateUrl: './icon-message-alert-outline.component.html',
    styleUrls: ['./icon-message-alert-outline.component.scss'],
    standalone: false
})
export class IconMessageAlertOutlineComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;

}
